var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapMarker = function SvgMapMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 2 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.182 20.206C17.659 13.028 18.5 12.25 18.5 9.75a6.75 6.75 0 1 0-13.5 0c0 2.5.843 3.281 5.318 10.456a1.688 1.688 0 0 0 2.864 0m-1.432-.894C7.27 12.13 6.687 11.676 6.687 9.75a5.062 5.062 0 1 1 10.125 0c0 1.918-.533 2.3-5.062 9.562m0-6.75a2.813 2.813 0 1 0 0-5.625 2.813 2.813 0 0 0 0 5.625"
  })));
};
export default SvgMapMarker;